import request from '../../../core/wrappers/axios-wrapper';
import { ApiURL } from '../../../types/constants/apiUrls/api-urls';
import { RequestType } from '../../../types/enums/request-enums';

const UpdateEndpointRateLimit = (data: any): Promise<any> =>
    request({
        url: ApiURL.Command.UpdateEndpointRateLimit,
        method: RequestType.POST,
        data,
    });

const OtpPasswordCommand = {
    UpdateEndpointRateLimit,
};

export default OtpPasswordCommand;
